
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.0069 1.55373L1.26491 24.2958C0.904527 24.6583 0.70224 25.1487 0.70224 25.6598C0.70224 26.171 0.904527 26.6614 1.26491 27.0239C1.6275 27.3849 2.1183 27.5875 2.62992 27.5875C3.14155 27.5875 3.63234 27.3849 3.99493 27.0239L26.7351 4.28375C27.0961 3.92116 27.2987 3.43037 27.2987 2.91874C27.2987 2.40712 27.0961 1.91632 26.7351 1.55373C26.3726 1.19334 25.8822 0.991058 25.371 0.991058C24.8599 0.991058 24.3695 1.19334 24.0069 1.55373V1.55373Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M26.7351 24.0375L3.99305 1.29551C3.63054 0.935121 3.14014 0.732834 2.62897 0.732834C2.11781 0.732834 1.62741 0.935121 1.2649 1.29551C0.903943 1.6581 0.701294 2.14889 0.701294 2.66052C0.701294 3.17214 0.903943 3.66294 1.2649 4.02553L24.0051 26.7638C24.3677 27.1248 24.8584 27.3274 25.3701 27.3274C25.8817 27.3274 26.3725 27.1248 26.7351 26.7638C27.0955 26.4013 27.2978 25.9109 27.2978 25.3997C27.2978 24.8886 27.0955 24.3982 26.7351 24.0357V24.0375Z","fill":"currentColor"}})])
          )
        }
      }
    